module.exports = __webpack_public_path__ + "img/lockBig.b10a544d.png";